import React from "react";
import { connect } from "react-redux";
import { MESSAGE_SENDED } from "../constants/actionTypes";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Dropzone from "react-dropzone";
import PrintLink from "./PrintLink";
import * as agent from "../agent";

class Templates extends React.Component {

    state = {
        uploadProgress: 0,
        fileLoading: false,
        extra: [],
        missed: []
    };

    onUpload = (files) => {

        this.setState({ fileLoading: true })

        const f = files[0];

        if (!["application/x-zip-compressed", "application/zip"].includes(f.type)) {
            window.alert("Неверный формат файла. Загружать необходимо zip-архив");
            this.setState({ fileLoading: false })
            return;
        }

        agent.Template.upload(
            "templates",
            files,
            e => this.setState({ uploadProgress: e.percent })
        )
        .then(res => {
            if (res === null) {
                this.setState({ fileLoading: false });
                this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: "Шаблоны обновлены", type: "success" } });
            } else {
                this.setState({ fileLoading: false, extra: res.extra, missed: res.missed });
                this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: "Некорректная структура архива", type: "error" } })
            }
        })
        .catch(e => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: e.message, type: "error" } }));
    }

    render() {

        let dropzoneRef;
        const { uploadProgress, fileLoading, extra, missed } = this.state;

        return (
            <div style={{ overflow: "hidden" }}>
                <Grid container justify="flex-start" spacing={16}>
                    <Grid item xs={3}>
                        <PrintLink href={agent.Template.getAll()} label="Скачать шаблоны" />
                    </Grid>
                    <Grid item xs={3}>
                        <Dropzone ref={(node) => { dropzoneRef = node; }} className="hidden-dropzone" onDrop={this.onUpload} />
                        <Button disabled={fileLoading}
                                color="primary"
                                size="large"
                                onClick={() => { dropzoneRef.open() }}
                                variant="contained" >
                            {fileLoading ? `Обработка файла... ${Math.round(uploadProgress)} %` : "Обновить шаблоны" }
                        </Button>
                    </Grid>
                </Grid>
                <br />
                <br />
                <Typography paragraph>Для успешного обновления шаблона необходимо соблюдать структуру папок и файлов в архиве. Все папки, соответствующие программам займов, должны располагаться в корне загружаемого ZIP-архива</Typography>
                {missed.length > 0 && <Typography paragraph>Список недостающих шаблонов: {missed.join(", ")}</Typography>}
                {extra.length > 0 && <Typography paragraph>Список посторонних файлов: {extra.join(", ")}</Typography>}
            </div>
        )
    }
}

export default connect(null, null)(Templates);



// WEBPACK FOOTER //
// ./src/components/Templates.js